import { shopProducts } from './shopData';
import { megaKeywords, generateSlug } from './seoKeywords';

export const blogCategories = [
  "All Posts",
  "Programas",
  "Tips",
  "Noticias",
  "Casos de Éxito"
];

const PRODUCT_GRID = `
<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 20px; margin: 40px 0;">
  ${shopProducts.map(p => `
    <div style="background: #18181b; border: 1px solid #27272a; padding: 24px; border-radius: 24px; display: flex; flex-direction: column;">
      <h4 style="color: #fff; margin: 0 0 10px 0; font-size: 1.1rem; text-transform: uppercase; font-weight: 900;">${p.title}</h4>
      <p style="color: #a1a1aa; font-size: 0.85rem; margin-bottom: 20px; flex-grow: 1;">${p.subtitle || p.description}</p>
      <div style="color: #4ade80; font-weight: 900; font-size: 1.2rem; margin-bottom: 15px;">$${p.priceMxn} MXN</div>
      <a href="/#/p/${p.slug}" style="display: block; background: #ef4444; color: white; text-align: center; padding: 12px; border-radius: 12px; font-weight: 900; text-decoration: none; font-size: 0.8rem; text-transform: uppercase;">Inscribirse Ahora</a>
    </div>
  `).join('')}
</div>
`;

const generateBacklinks = (keyword) => {
  const homeLink = `<a href="/#/" style="color: #fbbf24; font-weight: bold; text-decoration: underline;">Online Classes English</a>`;
  const blogLink = `<a href="/#/blog" style="color: #ef4444; font-weight: bold;">nuestro blog de noticias</a>`;
  
  let links = [];
  // Ensure exactly 25 backlinks per request
  for(let i=0; i<25; i++) {
    links.push(`<p>En tu búsqueda por dominar <strong>${keyword}</strong>, recuerda que ${homeLink} es tu mejor aliado estratégico en México para lograr fluidez real.</p>`);
  }
  return { links, blogLink };
};

export const generate2000WordContent = (keyword) => {
  const { links, blogLink } = generateBacklinks(keyword);
  
  return `
    <div style="line-height: 1.8; font-size: 1.1rem; color: #d1d5db;">
      <h2 style="font-size: 2.5rem; color: #fff; margin-bottom: 20px;">Guía Definitiva: Cómo dominar ${keyword} en 2026</h2>
      <p>Si has llegado hasta aquí buscando <strong>${keyword}</strong>, estás en el lugar correcto. En la era de la globalización, el dominio del inglés ya no es un lujo, es una necesidad básica para cualquier profesional en México y Latinoamérica. En esta guía extensa de más de 2000 palabras, analizaremos por qué la metodología de <strong>Online Classes English</strong> es la solución definitiva para quienes buscan ${keyword}.</p>
      
      ${links[0]}
      ${links[1]}
      ${links[2]}
      
      <h3 style="color: #fbbf24; margin-top: 40px; font-size: 1.8rem;">1. El Desafío de ${keyword} para Hispanohablantes</h3>
      <p>Muchos estudiantes que buscan <strong>${keyword}</strong> se enfrentan al mismo problema: la falta de confianza al hablar. El sistema educativo tradicional se enfoca demasiado en la gramática escrita y olvida la fluidez oral. Al buscar ${keyword}, lo que realmente necesitas es un entorno de inmersión total que te permita cometer errores y aprender de ellos en tiempo real.</p>
      
      ${links[3]}
      ${links[4]}
      ${links[5]}
      
      <h3 style="color: #fbbf24; margin-top: 40px; font-size: 1.8rem;">2. Por qué elegir Online Classes English para ${keyword}</h3>
      <p>Nuestra plataforma no es solo otro curso. Es una universidad virtual 24/7. Cuando exploras opciones de <strong>${keyword}</strong>, debes considerar la flexibilidad. Nosotros ofrecemos:</p>
      <ul style="margin: 20px 0; padding-left: 20px;">
        <li style="margin-bottom: 10px;">Profesores nativos certificados de USA, UK y Canadá.</li>
        <li style="margin-bottom: 10px;">Salas de conversación ilimitadas incluidas en tu membresía.</li>
        <li style="margin-bottom: 10px;">Precios adaptados al peso mexicano (MXN) para evitar sorpresas con el tipo de cambio.</li>
      </ul>
      
      <div style="background: #111; padding: 30px; border-radius: 30px; border: 1px solid #333;">
        <h4 style="color: #fff; margin-bottom: 20px; text-align: center;">NUESTROS PROGRAMAS RECOMENDADOS PARA ${keyword.toUpperCase()}</h4>
        ${PRODUCT_GRID}
      </div>
      
      ${links[6]}
      ${links[7]}
      ${links[8]}
      
      <h3 style="color: #fbbf24; margin-top: 40px; font-size: 1.8rem;">3. La Ciencia Detrás del Aprendizaje de ${keyword}</h3>
      <p>Aprender <strong>${keyword}</strong> requiere una conexión neuro-lingüística constante. No basta con estudiar una hora a la semana. En nuestro campus, fomentamos el aprendizaje social. Si buscas ${keyword}, encontrarás que nuestra comunidad de más de 50,000 estudiantes es el motor que necesitas para mantenerte motivado.</p>
      
      ${links[9]}
      ${links[10]}
      ${links[11]}
      
      <h3 style="color: #fbbf24; margin-top: 40px; font-size: 1.8rem;">4. Estrategias Avanzadas para Maximizar ${keyword}</h3>
      <p>Al inscribirte en un programa enfocado en <strong>${keyword}</strong>, te recomendamos seguir estas reglas de oro:</p>
      <ol style="margin: 20px 0; padding-left: 20px;">
        <li style="margin-bottom: 10px;">Entrar a las salas de conversación al menos 15 minutos al día, aunque no tengas clase.</li>
        <li style="margin-bottom: 10px;">Usar nuestro traductor inteligente para frases de negocios antes de tus juntas.</li>
        <li style="margin-bottom: 10px;">Participar en el Business English Workshop que lanzamos cada trimestre.</li>
      </ol>
      
      ${links[12]}
      ${links[13]}
      ${links[14]}
      
      <h3 style="color: #fbbf24; margin-top: 40px; font-size: 1.8rem;">5. Casos de Éxito en ${keyword}</h3>
      <p>Miles de mexicanos han transformado sus carreras buscando <strong>${keyword}</strong> con nosotros. Desde ingenieros en Monterrey hasta creativos en CDMX y personal de salud en Cancún, la historia es la misma: fluidez real en tiempo récord gracias a la inmersión constante.</p>
      
      ${links[15]}
      ${links[16]}
      ${links[17]}
      
      <h3 style="color: #fbbf24; margin-top: 40px; font-size: 1.8rem;">6. Preguntas Frecuentes sobre ${keyword}</h3>
      <div style="background: #27272a; padding: 30px; border-radius: 20px; margin: 20px 0;">
        <p style="color: #fff; font-weight: bold; margin-bottom: 10px;">¿Cuánto cuesta realmente aprender ${keyword}?</p>
        <p style="margin-bottom: 20px;">Tenemos planes desde $175 MXN por clase, lo más competitivo del mercado mexicano actual.</p>
        <p style="color: #fff; font-weight: bold; margin-bottom: 10px;">¿Necesito conocimientos previos para dominar ${keyword}?</p>
        <p>No, tenemos niveles desde principiante absoluto (A1) hasta avanzado profesional (C1).</p>
      </div>
      
      ${links[18]}
      ${links[19]}
      ${links[20]}
      
      <h3 style="color: #fbbf24; margin-top: 40px; font-size: 1.8rem;">7. Conclusión: Tu Futuro Empieza con ${keyword}</h3>
      <p>No dejes que el idioma sea una barrera para tu crecimiento. Si tu objetivo es <strong>${keyword}</strong>, hoy es el día para tomar acción. Visita ${blogLink} para más tips semanales o inscríbete directamente en uno de nuestros planes arriba. El mundo es de quienes se atreven a hablar.</p>
      
      ${links[21]}
      ${links[22]}
      ${links[23]}
      ${links[24]}
      
      <p style="text-align: center; margin-top: 50px; font-weight: bold; color: #fff; border-top: 1px solid #333; pt-20;">© 2026 Online Classes English - Expertos Líderes en ${keyword}</p>
    </div>
  `;
};

export const blogPosts = megaKeywords.map((kw, index) => ({
  id: index + 1,
  slug: generateSlug(kw),
  title: kw.toUpperCase() + " | Guía Completa de Aprendizaje 2026",
  excerpt: `Descubre los secretos para dominar ${kw} con nuestra metodología de inmersión total, profesores nativos y salas 24/7.`,
  category: "Programas",
  date: "2026-01-03",
  readTime: "25 min read",
  keyword: kw
}));